import { render, staticRenderFns } from "./BugReportModal.vue?vue&type=template&id=064c5e48&scoped=true"
import script from "./BugReportModal.vue?vue&type=script&lang=js"
export * from "./BugReportModal.vue?vue&type=script&lang=js"
import style0 from "./BugReportModal.vue?vue&type=style&index=0&id=064c5e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c5e48",
  null
  
)

export default component.exports